import GlobalNews from './GlobalNews';

export default GlobalNews;
